/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Switch, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import SoftTypography from "components/SoftTypography";

const tableStyle = {
  borderCollapse: "collapse",

  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "wrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",

  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};
const dataTable = [
  {
    id: uuidV4(),
    stt: "1",
    asset: "Thu nhập lãi và các khoản htu nhập tương tự",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "2",
    asset: "Chi trả lãi và các chi phí tương tự",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "3",
    asset: "Thu nhập lãi thuần (3)=(1)-(2)",
    readOnly: true,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "4",
    asset: "Thu nhập từ hoạt động dịch vụ",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "5",
    asset: "Chi phí hoạt động dịch vụ",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "6",
    asset: "Lãi/lỗ thuần từ hoạt động dịch vụ (6)=(4)-(5)",
    readOnly: true,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "7",
    asset: "Lãi/lỗ thuần từ hoạt động kinh doanh ngoại hối",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "8",
    asset: "Lãi/lỗ thuần từ mua bán chứng khoán kinh doanh",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "9",
    asset: "Lãi/lỗ thuần từ mua bán chứng khoán đầu tư",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "10",
    asset: "Thu nhập từ hoạt động khác",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "11",
    asset: "Chi phí hoạt động khác",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "12",
    asset: "Lãi/lỗ thuần từ hoạt động khác (12)=(10)-(11)",
    readOnly: true,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "13",
    asset: "Thu nhập từ góp vốn, mua cổ phần",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "14",
    asset: "Chi phí hoạt động",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "15",
    asset: "Chi phí dự phòng rủi ro tín dụng",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "16",
    asset: "Tổng lợi nhuận trước thuế (16)=(3)+(6)+(7)+(8)+(9)+(12)+(13)-(14)-(15)",
    readOnly: true,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "17",
    asset: "Lợi nhuận thuần từ hoạt động sản xuất kinh doanh (17=16-12)",
    readOnly: true,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "18",
    asset: "Tỷ suất lợi nhuận sử dụng xác định giá giao dịch liên kết (%)",
    readOnly: true,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
];
const stt = [
  "a",
  "b",
  "c",
  "d",
  "đ",
  "e",
  "g",
  "h",
  "i",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "x",
  "y",
];
export default function TableGDLK01e({ formData, setFieldValue }) {
  const [data1, setData1] = useState(false);
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  useEffect(() => {
    console.log(data1);
  }, [data1]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  // 1.2.abc
  const [data2, setData2] = useState([
    {
      id: uuidV4(),
      content: "",
      value3: 0,
      value4: 0,
      value5: "",
      value6: "",
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable2", data2);
  }, [data2]);
  const handleChange2 = (values) => {
    const { id, name, value, type } = values;
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data2 });
  };
  const handleChangeDate2 = (date, id) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect2 = (id, name, value) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd2 = () => {
    setData2((prev) => [
      ...prev,
      {
        id: uuidV4(),
        content: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: "",
        value7: 0,
        value8: 0,
        value9: 0,
        value10: "",
        value11: 0,
        value12a: 0,
        value12b: 0,
        value12c: 0,
        value12d: 0,
        value13: false,
      },
    ]);
  };
  const handleDelete2 = (id) => {
    setData2((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-start">
        <Typography variant="h6">
          2. Dành cho người nộp thuế thuộc các ngành ngân hàng, tín dụng
        </Typography>
      </Box>
      <Box>
        <table style={{ ...tableStyle, marginBottom: 50, marginTop: 50 }}>
          <tbody>
            <tr>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                }}
              >
                Người nộp thuế đã ký thỏa thuận trước về phương pháp xác định giá thuế (APA)
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  maxWidth: 100,
                }}
              >
                <Switch checked={data1} onChange={({ target: { checked } }) => setData1(checked)} />
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={2} style={{ textAlign: "center", width: 10 }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 400 }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Giá trị giao dịch liên kết
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 400 }}>
                Giá trị giao dịch với các bên độc lập
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 400 }}>
                Tổng giá trị phát sinh từ hoạt động kinh doanh trong kỳ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá trị xác định theo Hồ sơ xác định giá giao dịch liên kết
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá trị xác định giá theo APA
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>(1)</Td>
              <Td style={{ textAlign: "center" }}>(2)</Td>
              <Td style={{ textAlign: "center" }}>(3)</Td>
              <Td style={{ textAlign: "center" }}>(4)</Td>
              <Td style={{ textAlign: "center" }}>(5)</Td>
              <Td style={{ textAlign: "center" }}>(6) = (3) + (4) + (5)</Td>
            </tr>
            {data &&
              data.length > 0 &&
              data.map((rows, index) => (
                <tr key={index}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    style={{
                      textAlign: "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value3.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value3.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value3.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value3.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value3"
                        value={rows.value.value3.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value4.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value4.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value4.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value4.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value4"
                        value={rows.value.value4.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value5.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value5.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value5.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value5.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value5"
                        value={rows.value.value5.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value6.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value6.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value6.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value6.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value6"
                        value={rows.value.value6.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            {data2.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {stt[index] || "y"}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete2(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="content"
                    value={item.content}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}></Td>
                <Td style={{ background: "#ddeff3" }}></Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd2}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, readOnlyBackground, fontWeight, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: readOnlyBackground === true ? "#ddeff3" : "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        minWidth: 180,
        borderRadius: "0.5rem",
        fontWeight: fontWeight,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
